export default __webpack_public_path__ + "static/media/hand-with-chocolate-lyte@3x.bf5a2015.png";